import { createUserDisplayName } from "../../../../services/utils/index.js";

export default (setFieldValues, fieldName, fieldId, getUserId) => item => {
  setFieldValues({
    [fieldId]: getUserId ? item.user._id : item._id,
    [fieldName]: createUserDisplayName(item.user),
  });
};
